import React from "react";
import PropTypes from "prop-types";
import "./index.scss";
import TitleBlock from "./subcomponents/TitleBlock";
import Actions from "./subcomponents/Actions";
import ChannelTabs from "../ChannelTabs";

export default function ChannelHeader({
  title,
  description,
  primaryAction,
  secondaryAction,
  presence,
  tabs,
  activeTab,
  onSelectTab,
  onMore,
  className,
}) {
  const headerClassName = ["channel-header", "channel-header--workspace", className].filter(Boolean).join(" ");

  return (
    <header className={headerClassName} role="banner">
      <div className="channel-header__bar">
        <div className="channel-header__left">
          <TitleBlock title={title} description={description} presence={presence} />
        </div>
        <div className="channel-header__right">
          <Actions primaryAction={primaryAction} secondaryAction={secondaryAction} onMore={onMore} />
        </div>
      </div>

      <div className="channel-header__tabs">
        <ChannelTabs tabs={tabs} activeTab={activeTab} onSelect={onSelectTab} />
      </div>
    </header>
  );
}

ChannelHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  primaryAction: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
  }),
  secondaryAction: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
  }),
  presence: PropTypes.shape({
    isAvailable: PropTypes.bool,
    onlineCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    lastSeen: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  }),
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.node.isRequired,
    })
  ),
  activeTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelectTab: PropTypes.func,
  onMore: PropTypes.func,
  className: PropTypes.string,
};

ChannelHeader.defaultProps = {
  description: undefined,
  primaryAction: undefined,
  secondaryAction: undefined,
  presence: undefined,
  canDelete: false,
  onDelete: undefined,
  isDeletePending: false,
  tabs: undefined,
  activeTab: undefined,
  onSelectTab: undefined,
  onMore: undefined,
  className: undefined,
};
